var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cf2948;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.5,16.964a4.292,4.292,0,0,0-2.779-4.025V12.2a9.221,9.221,0,1,0-18.442,0v.739a4.306,4.306,0,0,0,1.491,8.331H8.311a.736.736,0,0,0,.733-.739V13.4a.736.736,0,0,0-.733-.739H7.6V12.2a6.9,6.9,0,1,1,13.794,0v.459h-.707a.736.736,0,0,0-.733.739v7.134a.736.736,0,0,0,.733.739h.328a5.068,5.068,0,0,1-4.269,3.057,1.088,1.088,0,0,0-1.061-.866h-2.4a1.083,1.083,0,0,0-1.086,1.1V25.8a1.083,1.083,0,0,0,1.086,1.1h2.4a1.065,1.065,0,0,0,1.061-.917,6.714,6.714,0,0,0,6.038-4.764A4.3,4.3,0,0,0,26.5,16.964Z",
    transform: "translate(-2.5 -2.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent25);
export default __webpack_public_path__ + "static/media/Component_25.f861111cb0206a74450647a4527d5c05.svg";
export { ForwardRef as ReactComponent };